import React, { JSX } from 'react';
import { ModuleConfig } from './Module';

export const MODULE_STATUS_NOT_SPECIFIED = `not_specified`;
export const MODULE_STATUS_LOADING_SCRIPT = `loading_script`;
export const MODULE_STATUS_FAILED_LOADING_SCRIPT = `failed_loading_script`;
export const MODULE_STATUS_FAILED_LOADING_MODULE = `failed_loading_module`;
export const MODULE_STATUS_ERROR_RENDERING_MODULE = `error_rendering_module`;

export interface IModulePlaceholderMap {
  [key: string]: (url?: string, moduleconfig?: ModuleConfig) => JSX.Element;
}

const logMessage = (msg: string, isError?: boolean) => {
  if (isError) {
    console.error(msg);
  } else {
    console.info(msg);
  }

  return <></>;
};

export const modulePlaceholderMap: IModulePlaceholderMap = {
  [MODULE_STATUS_NOT_SPECIFIED]: (url?: string, moduleConfig?: ModuleConfig) =>
    logMessage(
      `Module not specified url - ${moduleConfig?.url || ''}, appName - ${moduleConfig?.appName || ''}, module - ${moduleConfig?.module || ''}`,
      false
    ),
  [MODULE_STATUS_LOADING_SCRIPT]: (url?: string) => logMessage(`Loading dynamic script: ${url}`),
  [MODULE_STATUS_FAILED_LOADING_SCRIPT]: (url?: string) => logMessage(`Failed to load dynamic script: ${url}`, true),
  [MODULE_STATUS_FAILED_LOADING_MODULE]: (url?: string) => logMessage(`Failed Loading Module: ${url}`, true),
  [MODULE_STATUS_ERROR_RENDERING_MODULE]: () => <></>
};
